// Mediterranean Pool Tiles - Mega Menu JS
(function() {
  'use strict';

  var nav     = document.querySelector('.mpt-mega-nav');
  var overlay = document.getElementById('mptOverlay');
  if (!nav) return;

  // Measure header height
  function setHeaderHeight() {
    var hg = document.querySelector('.shopify-section-group-header-group');
    if (hg) {
      document.documentElement.style.setProperty('--header-height', hg.getBoundingClientRect().bottom + 'px');
    }
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  var openItem = null;

  function openPanel(item) {
    if (openItem && openItem !== item) closePanel(openItem);
    item.classList.add('mpt-mega-nav__item--open');
    var btn = item.querySelector('button');
    var panel = item.querySelector('.mpt-mega-panel');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (panel) panel.classList.add('mpt-mega-panel--open');
    if (overlay) overlay.classList.add('mpt-mega-overlay--visible');
    openItem = item;
    setHeaderHeight();
  }

  function closePanel(item) {
    item.classList.remove('mpt-mega-nav__item--open');
    var btn = item.querySelector('button');
    var panel = item.querySelector('.mpt-mega-panel');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) panel.classList.remove('mpt-mega-panel--open');
    openItem = null;
  }

  function closeAll() {
    nav.querySelectorAll('.mpt-mega-nav__item--open').forEach(closePanel);
    if (overlay) overlay.classList.remove('mpt-mega-overlay--visible');
  }

  // Click toggle
  nav.querySelectorAll('.mpt-mega-nav__item[data-panel]').forEach(function(item) {
    var btn = item.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      if (item.classList.contains('mpt-mega-nav__item--open')) {
        closeAll();
      } else {
        openPanel(item);
      }
    });
  });

  // Close on overlay/outside/Escape
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('click', function(e) { if (!nav.contains(e.target)) closeAll(); });

  // Hover
  nav.querySelectorAll('.mpt-mega-nav__item[data-panel]').forEach(function(item) {
    var leaveTimer;
    item.addEventListener('mouseenter', function() {
      clearTimeout(leaveTimer);
      openPanel(item);
    });
    item.addEventListener('mouseleave', function() {
      leaveTimer = setTimeout(closeAll, 180);
    });
    var panel = item.querySelector('.mpt-mega-panel');
    if (panel) {
      panel.addEventListener('mouseenter', function() { clearTimeout(leaveTimer); });
      panel.addEventListener('mouseleave', function() {
        leaveTimer = setTimeout(closeAll, 180);
      });
    }
  });

  // Top bar fix (remove Handmade in Morocco, fix phone)
  function fixTopBar() {
    var topBarSection = document.querySelector('[id*="custom_top_bar"]');
    if (!topBarSection) return;
    topBarSection.querySelectorAll('*').forEach(function(el) {
      if (el.children.length === 0 && el.textContent.trim() === 'Handmade in Morocco') {
        var parent = el.closest('div, p, span, li') || el;
        parent.style.display = 'none';
      }
    });
    topBarSection.querySelectorAll('a').forEach(function(link) {
      var text = link.textContent.trim().toLowerCase();
      if (text.indexOf('quote') !== -1 || text === 'get a quote') {
        link.style.display = 'none';
      }
    });
    topBarSection.querySelectorAll('a[href^="tel"]').forEach(function(link) {
      link.style.cssText += 'display:inline-flex!important;align-items:center!important;gap:8px!important;font-size:12px!important;color:rgba(26,22,18,0.65)!important;text-decoration:none!important;';
      if (link.textContent.indexOf('Call:') !== -1) {
        var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox','0 0 24 24');
        icon.setAttribute('fill','none');
        icon.setAttribute('stroke','#B38B65');
        icon.setAttribute('stroke-width','1.4');
        icon.setAttribute('stroke-linecap','round');
        icon.setAttribute('stroke-linejoin','round');
        icon.style.cssText = 'width:15px;height:15px;flex-shrink:0;display:block;';
        icon.innerHTML = '<g fill="none" stroke="#B38B65" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C9.61 21 3 14.39 3 6.25A1 1 0 0 1 4 5.25h3.5a1 1 0 0 1 1 1c0 1.26.2 2.47.57 3.59a1 1 0 0 1-.25 1.02z"/></g>';
        link.insertBefore(icon, link.firstChild);
        link.childNodes.forEach(function(node) {
          if (node.nodeType === 3 && node.textContent.indexOf('Call:') !== -1) {
            node.textContent = node.textContent.replace('Call:', '').trim();
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixTopBar);
  } else {
    fixTopBar();
  }

  // Homepage transparent header
  if (window.location.pathname === '/') {
    var topBar = document.querySelector('[id*="custom_top_bar"]');
    var headerSection = document.querySelector('[id*="__header"]');
    var headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    if (topBar) topBar.style.cssText = 'position:fixed!important;top:0!important;left:0!important;right:0!important;width:100%!important;z-index:501!important;';
    if (headerSection) {
      var tbH = 0; if(topBar){ tbH = topBar.offsetHeight; }
      headerSection.style.cssText = 'position:fixed!important;top:' + tbH + 'px!important;left:0!important;right:0!important;width:100%!important;z-index:500!important;';
    }

    function checkScroll() {
      var solid = window.scrollY > window.innerHeight * 0.75;
      headerWrapper.classList.toggle('mpt-solid', solid);
      if (topBar) topBar.classList.toggle('mpt-solid', solid);
      if (headerSection) headerSection.classList.toggle('mpt-solid', solid);
    }
    window.addEventListener('scroll', checkScroll, {passive: true});
    checkScroll();
  }

})();
